import { IChatMarkedAsUnreadEventPayloadResponse } from 'APP/model/counter/counterModel.types';
import Entities from 'STORE';

import { GroupsEvent } from '../GroupsEvent';

export class ConfigGroupUnread extends GroupsEvent<IChatMarkedAsUnreadEventPayloadResponse> {
  process(): void {
    const { groupId, unread = false } = this.eventPayload!;
    const group = Entities.GroupsStore.getGroupById(groupId.toString());
    if (group) {
      group.setUnread(unread);
    }
  }
}
